import { useContext } from "react";
import { BooleanField, Datagrid, List, TextField } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";


export const ProcessTypeList = (props) => {
    const context = useContext(AppContext)

    return <List exporter={false} bulkActionButtons={false}
        title={'Tipos de processo'}
        {...props}>
        <Datagrid rowClick={'edit'}>
            {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
            {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
            <TextField source="type" label={'Tipo'} />
            <TextField source="name" label={'Complemento'} />
            <BooleanField source='pje' label={'PJE?'} />
        </Datagrid>
    </List>
}